interface IForm {
    id?: number;
    uniqueId?: string;
    status?: string;
    submittedUserId?: number;
    submitted?: Date;
    updatedByUserId?: number;
    updated?: Date;
    jobCorpsCenterId?: number;
    type?: string;
    actionLevel?: string;
    isActive?: boolean;
    action?: string;
}

export default abstract class Form {
    public id?: number;
    public uniqueId?: string;
    public status?: string;
    public submittedUserId?: number;
    public submitted?: Date;
    public updatedByUserId?: number;
    public updated?: Date;
    public jobCorpsCenterId?: number;
    public type?: string;
    public actionLevel?: string;
    public isActive?: boolean;
    public action?: string;

    constructor(f: IForm) {
        this.id = f.id;
        this.uniqueId = f.uniqueId;
        this.status = f.status;
        this.submitted = f.submitted;
        this.submittedUserId = f.submittedUserId;
        this.updatedByUserId = f.updatedByUserId  !== 0 ? f.updatedByUserId : undefined;
        this.updated = f.updated;
        this.jobCorpsCenterId = f.jobCorpsCenterId;
        this.type = f.type ? f.type.replace('_', ' ') : undefined;
        this.actionLevel = f.actionLevel;
        this.action = f.action;
    }
}

export { Form, IForm };
